import { Crown, UserMinus, ArrowRightLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Avatar } from "../Avatar";

export function MemberTable({ clan, meId, onUpdate }) {
  const act = async (path, user_id, okMsg) => {
    try {
      const { data } = await api.post(`/clans/mine/${path}`, { user_id });
      onUpdate(data);
      toast.success(okMsg);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Action failed");
    }
  };

  return (
    <div className="panel p-6" data-testid="member-table">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[10px] tracking-[0.3em] text-muted-foreground">// MEMBER RANKINGS</div>
        <div className="text-[10px] tracking-widest text-muted-foreground" data-testid="member-count">{clan.member_count} / {clan.max_members} MEMBERS</div>
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[10px] tracking-widest text-muted-foreground text-left">
            <th className="py-2 w-10">#</th>
            <th className="py-2">MEMBER</th>
            <th className="py-2 text-right">BEST</th>
            <th className="py-2 text-right hidden sm:table-cell">RUNS</th>
            {clan.is_owner && <th className="py-2 text-right">ACTIONS</th>}
          </tr>
        </thead>
        <tbody>
          {clan.members.map((m) => (
            <tr key={m.user_id} className={`border-t border-border ${m.user_id === meId ? "bg-primary/5" : ""}`} data-testid={`member-row-${m.user_id}`}>
              <td className={`py-3 font-bold ${m.rank === 1 && m.best !== null ? "text-amber-300" : "text-muted-foreground"}`}>{m.rank}</td>
              <td className="py-3">
                <Avatar id={m.avatar} bg={m.avatar_bg} size={28} className="inline-block align-middle mr-2" testid={`member-avatar-${m.user_id}`} />
                <span className="font-semibold align-middle">{m.name}</span>
                {m.is_owner && <Crown className="w-3.5 h-3.5 inline ml-2 text-amber-300" data-testid="owner-crown" />}
                {m.user_id === meId && <span className="ml-2 text-[9px] tracking-widest text-phosphor">YOU</span>}
              </td>
              <td className="py-3 text-right font-bold tabular-nums" data-testid={`member-best-${m.user_id}`}>
                {m.best === null ? <span className="text-muted-foreground/50">—</span> : <span className="text-phosphor">{m.best}</span>}
              </td>
              <td className="py-3 text-right text-muted-foreground tabular-nums hidden sm:table-cell">{m.sessions}</td>
              {clan.is_owner && (
                <td className="py-3 text-right">
                  {m.user_id !== meId && (
                    <div className="inline-flex gap-1">
                      <button onClick={() => act("transfer", m.user_id, `${m.name} now owns the clan`)} title="Transfer ownership" data-testid={`transfer-${m.user_id}`}
                        className="p-1.5 border border-border hover:border-amber-300 hover:text-amber-300"><ArrowRightLeft className="w-3.5 h-3.5" /></button>
                      <button onClick={() => act("kick", m.user_id, `${m.name} removed`)} title="Remove member" data-testid={`kick-${m.user_id}`}
                        className="p-1.5 border border-border hover:border-destructive hover:text-destructive"><UserMinus className="w-3.5 h-3.5" /></button>
                    </div>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {!clan.challenge && <div className="mt-3 text-xs text-muted-foreground">Scores appear once a challenge is set and members play it.</div>}
    </div>
  );
}
